import { render } from "./PEarnbySharing.vue?vue&type=template&id=3d9e8200&scoped=true"
import script from "./PEarnbySharing.vue?vue&type=script&lang=js"
export * from "./PEarnbySharing.vue?vue&type=script&lang=js"

import "./PEarnbySharing.vue?vue&type=style&index=0&id=3d9e8200&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d9e8200"]])

export default __exports__